import { Component } from '@theme/component';

class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#injectTableOfContents();
  }

  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  #slugify(text) {
    const base = (text || '').trim().toLowerCase()
      .replace(/[\s　]+/g, '-')
      .replace(/[^a-z0-9\-_]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    return base;
  }

  #isHeadingForToc(h) {
    if (h.querySelector('img, picture, video, iframe, svg')) return false;
    const text = (h.textContent || '').replace(/\s|　/g, '');
    return text.length > 0;
  }

  #injectTableOfContents() {
    if (this.querySelector('.article-toc')) return;
    const headings = Array.from(this.querySelectorAll('h2')).filter((h) => this.#isHeadingForToc(h));
    if (headings.length < 2) return;

    const usedIds = new Set();
    headings.forEach((h, i) => {
      if (!h.id) {
        const slug = this.#slugify(h.textContent);
        let id = slug || `section-${i + 1}`;
        let n = 2;
        while (usedIds.has(id) || document.getElementById(id)) {
          id = `${slug || 'section'}-${n++}`;
        }
        h.id = id;
      }
      usedIds.add(h.id);
    });

    const nav = document.createElement('nav');
    nav.className = 'article-toc';
    nav.setAttribute('aria-label', '目次');
    nav.setAttribute('role', 'doc-toc');

    const title = document.createElement('p');
    title.className = 'article-toc__title';
    title.textContent = '目次';

    const list = document.createElement('ul');
    list.className = 'article-toc__list';

    const itemListElements = [];
    headings.forEach((h, i) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'article-toc__link';
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', (event) => {
        event.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', `#${h.id}`);
      });
      li.appendChild(a);
      list.appendChild(li);
      itemListElements.push({
        '@type': 'ListItem',
        position: i + 1,
        name: h.textContent.trim(),
        url: `${location.origin}${location.pathname}#${h.id}`
      });
    });

    nav.append(title, list);
    headings[0].before(nav);

    const ld = document.createElement('script');
    ld.type = 'application/ld+json';
    ld.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: '目次',
      itemListElement: itemListElements
    });
    nav.appendChild(ld);
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
